<template>
    <button
        type="button"
        class="button-icon"
        :disabled="disabled"
        :aria-label="ariaLabel"
    >
        <div class="button-icon-content">
            <slot />
        </div>
    </button>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{
    disabled?: boolean
    ariaLabel?: string
}>(), {
    disabled: false,
})
</script>

<style lang="scss" scoped>
.button-icon {
    height: 30px;
    width: 30px;
    border: none;
    background-color: #fff;
    border-radius: var(--border-radius-small);
    box-shadow: 0 0 10px -3px rgba(0, 0, 0, .3);
    transition: 0.2s ease-in-out;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    padding: 0px;

    &:focus {
        outline: 1px solid var(--color-black);
    }

    .button-icon-content {
        height: 30px;
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: .7;
        transition: 0.2s ease-in-out;
        pointer-events: none;
        background-color: var(--color-gray-light);
        :global(i) {
            display: inline-flex;
        }
    }

    &:disabled {
        opacity: .5;
        cursor: var(--tl-cursor-disabled);
    }

    &:hover {
        background-color: var(--color-gray);
        .button-icon-content {
            opacity: 1;
        }
    }
}
</style>
